/**
 * Copyright Mántum All Rights Reserved.
 */
import Form from '../kanela';
import { Fragment, lazy, Suspense, useRef } from 'react';
import { constants as layouts } from '@mantum/kanela';

import type {
    Action,
    Kanela,
    Layout,
    Layouts,
    Sections,
    Tabs
} from '@mantum/kanela';

const Sidebar = lazy(() => {
    return import('./sidebar-screen');
});

const Detail = lazy(() => {
    return import('./sidebar-screen/detail');
});

type PropTypes = {
    action?: Action;
    entity?: number | string;
    env?: Record<string, unknown>;
    layout: Layout;
    onClick?: (name?: string, value?: unknown) => void;
    page?: Sections | Tabs;
    sidebar?: Sections | Tabs;
};

export default function Page(props: PropTypes) {
    const pageRef = useRef<Kanela>(null);
    const sidebarRef = useRef<Kanela>(null);

    const onClear = () => {
        sidebarRef.current?.clear();
    };

    const onSuccessSubmit = (refresh?: string[]) => {
        sidebarRef.current?.clear();
        if (pageRef.current && pageRef.current.refresh) {
            pageRef.current.refresh(refresh);
        }
    };

    const open = props.entity !== undefined && props.entity !== null;

    const content = <Form ref={pageRef} options={props.page} />;

    const component: Record<Layouts, JSX.Element> = {
        [layouts.SIDEBAR_SCREEN_LAYOUT]: (
            <Sidebar
                action={props.action}
                content={content}
                description={props.layout.description}
                formRef={sidebarRef}
                onClear={onClear}
                onSuccessSubmit={onSuccessSubmit}
                open={open}
                title={props.layout.title}
            >
                <Detail
                    action={props.action}
                    entity={props.entity}
                    env={props.env}
                    onClick={props.onClick}
                    options={props.sidebar}
                    ref={sidebarRef}
                />
            </Sidebar>
        )
    };

    return (
        <Suspense>{component[props.layout.template] || <Fragment />}</Suspense>
    );
}
